import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../services/general.service';
import { AuditService } from 'src/app/services/audit.service';
import { exit } from 'process';
import { DatePipe } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-audit_create',
  templateUrl: './audit_create.component.html',
  styleUrls: ['./audit_create.component.css']
})

export class AuditCreateComponent implements OnInit {

  @Input() ID: string;
  @Input() SID: string;
  @Input() PID: string;
  @Input() lang;
  @Input() type: string;
  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  typeConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  serviceId: string;
  plan_id: string;
  intervention_id: string;
  // lang: any;
  generalLang: any;
  record: any;
  mode: string;
  data_action: any;

  //common data
  data: any;

  imageLink: any;
  id: number;
  action: any;
  dropdownList:any;
  selDropdownList:any;
  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;
  auditorItems: FormArray;
  standards:any;
  dropdownSettings = {}
  start_date;
  end_date;
  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private auditService: AuditService,
    private router: Router,
    private route: ActivatedRoute,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private datePipe: DatePipe
  ) { }

  get audits(): FormArray {
    return <FormArray>this.createForm.get('auditorArr');
  }  

  addAudit(contact: any) {
    this.audits.push(this.createAudit(contact));
  }

  createAudit(record: any): FormGroup {
    return this.formBuilder.group({  
      auditor: [record.auditor_id, [Validators.required]],
      function: [record.function, [Validators.required]]
    })
  }


  ngOnInit() {

    if(this.type == "add"){
      this.modalTitle = "NEW AUDIT"
    }else{
      this.modalTitle = "EDIT AUDIT"
    }
    this.FormBuild();
    this.getDropdown();
    
    if(this.ID){
      this.getData();
    }
      
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: false,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

  }

  getControls() {
    return (this.createForm.get('auditorArr') as FormArray).controls;
  }

  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      auditorArr: this.formBuilder.array([]),
      audit_no: ['', [Validators.required]],
      standard_id: ['', [Validators.required]],
      notes: ['', [Validators.required]],
      description: ['', [Validators.required]],
      company: ['', [Validators.required]],
      company_address: ['', [Validators.required]],
      company_contact: ['', [Validators.required]],
      iaf_main: ['', [Validators.required]],
      scope_cert: ['', [Validators.required]],
      start_date: ['', [Validators.required]],
      end_date: ['', [Validators.required]],
      chapter_id: ['', [Validators.required]],
      audit_id: this.ID,
      action: (this.type == "add")?'add_audit':'edit_audit',
    });
    if(parseInt(this.ID )> 0){
      this.addItem()
    }
  }

 

  selectStdId(event){
    let auditId = "0"
    if(event.target.value){
      this.getStandardClauseDropdown(event.target.value,auditId)
    }

  }

  getStandardClauseDropdown(std_id,audit_id){
    this.auditService.getStdClauseDropdown(std_id,audit_id).subscribe(
      res =>{
        this.dropdownList = res.data.dropdown
        this.selDropdownList = res.data.selected_dropdown
      })        
  }

  getDropdown(){
    this.auditService.getAuditDrodown().subscribe(
      res =>{
        let stdArr = res.data.standards        
        this.standards = this.convertStandardDropdown(stdArr)
      })
  }

  convertStandardDropdown(obj) {
    let resultArr = []
    for (const item in obj) {
      let eachObj = {
        "standard_id":obj[item].standard_id,
        "standard_title":obj[item].standard_title,
      }
      resultArr.push(eachObj)
    }
    return resultArr
  }

  FormBuildUpdate(): void {
    console.log("==== Start Date =====")
    console.log(this.record)
    this.createForm.patchValue({
      audit_no: this.record.audit_no,
      standard_id: this.record.standard_id,
      notes: this.record.notes,
      description: this.record.description,
      company: this.record.company,
      company_address: this.record.company_address,
      company_contact: this.record.company_contact,
      iaf_main: this.record.iaf_main,
      scope_cert: this.record.scope_cert,
      // start_date: this.record.start_date,
      // end_date: this.record.end_date,
      chapter_id: this.record.refering_date,
    });

  }

  addAuditorItem(){
    return this.formBuilder.group({
      auditor: new FormControl('', [Validators.required]),
      function: new FormControl('', [Validators.required])
    });    
  }

  addItem(): void {
    this.auditorItems = this.createForm.get('auditorArr') as FormArray;
    this.auditorItems.push(this.addAuditorItem());
  }

  removeItem(index)
  {
  this.auditorItems.removeAt(index);
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }


  getData() {
    this.auditService.getAuditInfo(this.ID).subscribe(
      res =>{
        this.record = res.data.form_data
        let start_date = new Date(this.record.start_date)
        let end_date   = new Date(this.record.end_date)

        this.record.auditors.forEach(item => {
          console.log("---- Item --------")
          console.log(item)
          this.addAudit(item)
        })
        
        this.start_date = this.datePipe.transform(start_date, 'yyyy-MM-dd');
        this.end_date   = this.datePipe.transform(end_date, 'yyyy-MM-dd');        
        this.getStandardClauseDropdown(this.record.standard_id,this.ID)
        this.FormBuildUpdate()
      })    
  }


  onSubmit() {
    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

    this.auditService.addAudit(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();

          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.AUDIT_LIST]);
            });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }

}
